// extracted by mini-css-extract-plugin
export default {"table":"table__uKrRW","table__head":"table__head__cxnGG","table__cell":"table__cell__qtSL5","value":"value__aJYPv","table__row":"table__row__xrOi8","percentage":"percentage__Xw2xz"};